
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30507',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30507",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54899",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8135",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11589",
  "I18n": "static-7.1639",
  "quartz": "static-1.7179",
  "quartz-config": "static-1.957",
  "quartz-core": "static-1.6398",
  "react-dlb": "static-1.81",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.825",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54886",
  "feedback-utils": "static-1.54890",
  "forms-embed-utils-lib": "static-1.4581",
  "forms-utils-lib": "static-1.12805",
  "foundations-assets": "static-1.4988",
  "foundations-components": "static-1.8167",
  "foundations-theming": "static-1.4547",
  "hub-http": "static-1.6338",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11896",
  "icons": "static-2.654",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4002",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16799",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5426",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.489",
  "tinymce-plugins": "static-1.57797",
  "transmute": "static-2.85",
  "ui-images": "static-2.1183",
  "UIComponents": "static-3.8535",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3481",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3456",
  "quartz-webpack": "static-1.3403",
  "foundations-theming-specialty": "static-1.2263",
  "property-description-translator": "static-1.3956",
  "HeadJS": "static-2.771",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3246",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4441",
  "jasmine-runner": "static-1.6573",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.846",
  "hubspotter-http": "static-1.4735",
  "mobile-manifest-mixins": "static-1.545",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.854",
  "quartz-head": "static-1.844",
  "quartz-i18n": "static-1.854",
  "quartz-routing": "static-1.609",
  "quartz-test": "static-1.854",
  "quartz-tracking": "static-1.558",
  "trellis-components": "static-1.2214",
  "ui-fonts": "static-1.851",
  "usage-tracker-container": "static-1.7454",
  "usage-tracker-core": "static-1.7314",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7362",
  "reference-resolvers": "static-1.8290",
  "sanitize-text": "static-1.8260",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10477",
  "sanitize": "static-1.4591",
  "outpost": "static-1.4285",
  "rpc-client-utils": "static-1.4772",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4436",
  "floating-ui": "static-1.58",
  "hs-story-utils": "static-1.9538",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.37",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2195",
  "bend-plugin-foundations-theming": "static-1.3030",
  "foundations-theming-base": "static-1.3532",
  "stylex": "static-1.35",
  "hs-locale-management": "static-1.166",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9253",
  "atom": "static-1.5190",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7942",
  "ContentUtils": "static-1.68706",
  "data-token-picker": "static-1.16619",
  "file-manager-components": "static-1.23955",
  "FileManagerCore": "static-1.39454",
  "FileManagerLib": "static-1.39595",
  "frontend-preferences-client": "static-1.8042",
  "hub-http-contrib": "static-1.3158",
  "interframe": "static-3.4875",
  "layout-dnd-components": "static-1.12676",
  "layout-dnd-utils": "static-1.11651",
  "property-translator": "static-1.5512",
  "react-codemirror": "static-1.10742",
  "react-colorpicker": "static-2.10322",
  "reference-resolvers-lite": "static-1.8212",
  "rich-text-lib": "static-1.20037",
  "tinymce-data": "static-1.40768",
  "tinymce-themes": "static-1.56653",
  "ui-addon-emoji-picker": "static-1.10002",
  "ui-addon-sales-email": "static-1.5325",
  "ui-brand-identity-lib": "static-1.15706",
  "bender-build-tools": "static-1.3297",
  "hub-http-shared-msw-handlers": "static-1.10255",
  "hubspotter-http-shared-msw-handlers": "static-1.10253",
  "usage-tracker-session-replay": "static-1.5150",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1056",
  "tanstack-virtual": "static-1.31",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.182",
  "chirp-fetch": "static-1.2003",
  "chatspot-core": "static-1.21850",
  "copilot-toolkit": "static-1.11437",
  "customer-data-objects-ui-components": "static-1.13144",
  "data-fetching-client": "static-1.9777",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4874",
  "ui-addon-video-player": "static-1.8819",
  "ui-coaching-tips": "static-1.28887",
  "usage-tracker": "static-1.7464",
  "cms-field-types": "static-1.4930",
  "content-icons-ui": "static-1.2259",
  "integrations-lib": "static-1.16530",
  "customer-data-objects": "static-1.7793",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1125",
  "apollo-link-hub-http": "static-2.4766",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4265",
  "ui-addon-iframeable": "static-1.9182",
  "video-components-external": "static-1.11657",
  "video-data-lib": "static-1.35315",
  "audio-components": "static-1.6098",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29520",
  "FileManagerImages": "static-1.37106",
  "foundations-components-legacy": "static-1.1192",
  "html-to-image": "static-1.55",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.527",
  "ui-universal-auth": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "urlinator": "static-1.4651",
  "video-components": "static-1.13659",
  "video-embed": "static-1.36149",
  "ts-schema": "static-1.4166",
  "ContentData": "static-1.68781",
  "layout-data-lib": "static-1.9976",
  "react-dnd-compat": "static-1.4730",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1658",
  "external-options-client-types": "static-1.4211",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7008",
  "hs-promise-utils": "static-1.5708",
  "inbound-db-properties-service-client": "static-1.3931",
  "NamespacedHubStyle": "static-2.9138",
  "growth-onboarding-confetti": "static-1.3180",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11264",
  "unified-auth-core-lib": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5627",
  "magpie-types": "static-1.5087",
  "simple-logging-lib": "static-1.3164",
  "avatar-components": "static-1.2613",
  "customer-data-ui-utilities": "static-1.9940",
  "growth-onboarding-feedback-components": "static-1.6693",
  "flux-actions": "static-1.346",
  "hubspot-apollo-client": "static-1.4993",
  "integrations-error-boundary-lib": "static-1.13945",
  "integrations-tracking-lib": "static-1.5721",
  "laboratory-lib": "static-3.7268",
  "native-integrations-shared-strings": "static-1.7897",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10363",
  "unified-auth": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "breeze-engine-core": "static-1.403",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "navigation-messaging": "static-1.7627",
  "content-media-composition-data-lib": "static-1.12673",
  "content-media-compositions": "static-2.16680",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19132",
  "social-insights-client-types": "static-1.22346",
  "advanced-menus-core": "static-1.15326",
  "advanced-menus-lib": "static-1.12237",
  "ExportDialog": "static-6.10495",
  "ui-memberships-settings-lib": "static-1.34358",
  "conditional-properties-service-client": "static-1.3882",
  "crm-pipelines-api-client-types": "static-1.4221",
  "fdsr-migration-layer": "static-1.127",
  "framework-builder-read-service-client": "static-1.4088",
  "framework-data-schema-quick-fetch": "static-1.6913",
  "inbound-db-meta-service-client": "static-1.3671",
  "multi-currency-client-types": "static-1.3775",
  "persist-promise": "static-1.3815",
  "foundations-components-test-utils": "static-1.5650",
  "fsm": "static-1.3843",
  "adobe-sign-auth-lib": "static-1.21",
  "ads-unified-auth-lib": "static-1.389",
  "google-sheets-integration-lib": "static-1.585",
  "microsoft-drive-integration-lib": "static-1.718",
  "surveymonkey-integration-lib": "static-1.41",
  "slack-ui-library": "static-1.10511",
  "reactive-lib": "static-1.841",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.452",
  "universal-page-editor-lib": "static-1.3131",
  "js-cookie": "static-1.18",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15325",
  "simple-menus-lib": "static-1.16842",
  "crm-record-cards-service-types": "static-1.3671",
  "location-customization-utils-lib": "static-1.9601",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30507",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54899",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8135",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11589",
  "I18n": "/I18n/static-7.1639",
  "quartz": "/quartz/static-1.7179",
  "quartz-config": "/quartz-config/static-1.957",
  "quartz-core": "/quartz-core/static-1.6398",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.825",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54886",
  "feedback-utils": "/feedback-utils/static-1.54890",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4581",
  "forms-utils-lib": "/forms-utils-lib/static-1.12805",
  "foundations-assets": "/foundations-assets/static-1.4988",
  "foundations-components": "/foundations-components/static-1.8167",
  "foundations-theming": "/foundations-theming/static-1.4547",
  "hub-http": "/hub-http/static-1.6338",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11896",
  "icons": "/icons/static-2.654",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4002",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16799",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5426",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tinymce-plugins": "/tinymce-plugins/static-1.57797",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1183",
  "UIComponents": "/UIComponents/static-3.8535",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3481",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3456",
  "quartz-webpack": "/quartz-webpack/static-1.3403",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2263",
  "property-description-translator": "/property-description-translator/static-1.3956",
  "HeadJS": "/HeadJS/static-2.771",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3246",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4441",
  "jasmine-runner": "/jasmine-runner/static-1.6573",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.846",
  "hubspotter-http": "/hubspotter-http/static-1.4735",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.545",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.854",
  "quartz-head": "/quartz-head/static-1.844",
  "quartz-i18n": "/quartz-i18n/static-1.854",
  "quartz-routing": "/quartz-routing/static-1.609",
  "quartz-test": "/quartz-test/static-1.854",
  "quartz-tracking": "/quartz-tracking/static-1.558",
  "trellis-components": "/trellis-components/static-1.2214",
  "ui-fonts": "/ui-fonts/static-1.851",
  "usage-tracker-container": "/usage-tracker-container/static-1.7454",
  "usage-tracker-core": "/usage-tracker-core/static-1.7314",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7362",
  "reference-resolvers": "/reference-resolvers/static-1.8290",
  "sanitize-text": "/sanitize-text/static-1.8260",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10477",
  "sanitize": "/sanitize/static-1.4591",
  "outpost": "/outpost/static-1.4285",
  "rpc-client-utils": "/rpc-client-utils/static-1.4772",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4436",
  "floating-ui": "/floating-ui/static-1.58",
  "hs-story-utils": "/hs-story-utils/static-1.9538",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.37",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2195",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3030",
  "foundations-theming-base": "/foundations-theming-base/static-1.3532",
  "stylex": "/stylex/static-1.35",
  "hs-locale-management": "/hs-locale-management/static-1.166",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9253",
  "atom": "/atom/static-1.5190",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7942",
  "ContentUtils": "/ContentUtils/static-1.68706",
  "data-token-picker": "/data-token-picker/static-1.16619",
  "file-manager-components": "/file-manager-components/static-1.23955",
  "FileManagerCore": "/FileManagerCore/static-1.39454",
  "FileManagerLib": "/FileManagerLib/static-1.39595",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8042",
  "hub-http-contrib": "/hub-http-contrib/static-1.3158",
  "interframe": "/interframe/static-3.4875",
  "layout-dnd-components": "/layout-dnd-components/static-1.12676",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11651",
  "property-translator": "/property-translator/static-1.5512",
  "react-codemirror": "/react-codemirror/static-1.10742",
  "react-colorpicker": "/react-colorpicker/static-2.10322",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8212",
  "rich-text-lib": "/rich-text-lib/static-1.20037",
  "tinymce-data": "/tinymce-data/static-1.40768",
  "tinymce-themes": "/tinymce-themes/static-1.56653",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10002",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5325",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15706",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10255",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10253",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5150",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1056",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.182",
  "chirp-fetch": "/chirp-fetch/static-1.2003",
  "chatspot-core": "/chatspot-core/static-1.21850",
  "copilot-toolkit": "/copilot-toolkit/static-1.11437",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13144",
  "data-fetching-client": "/data-fetching-client/static-1.9777",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4874",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8819",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28887",
  "usage-tracker": "/usage-tracker/static-1.7464",
  "cms-field-types": "/cms-field-types/static-1.4930",
  "content-icons-ui": "/content-icons-ui/static-1.2259",
  "integrations-lib": "/integrations-lib/static-1.16530",
  "customer-data-objects": "/customer-data-objects/static-1.7793",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1125",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4766",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4265",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9182",
  "video-components-external": "/video-components-external/static-1.11657",
  "video-data-lib": "/video-data-lib/static-1.35315",
  "audio-components": "/audio-components/static-1.6098",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29520",
  "FileManagerImages": "/FileManagerImages/static-1.37106",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1192",
  "html-to-image": "/html-to-image/static-1.55",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.527",
  "ui-universal-auth": "/ui-universal-auth/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "urlinator": "/urlinator/static-1.4651",
  "video-components": "/video-components/static-1.13659",
  "video-embed": "/video-embed/static-1.36149",
  "ts-schema": "/ts-schema/static-1.4166",
  "ContentData": "/ContentData/static-1.68781",
  "layout-data-lib": "/layout-data-lib/static-1.9976",
  "react-dnd-compat": "/react-dnd-compat/static-1.4730",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1658",
  "external-options-client-types": "/external-options-client-types/static-1.4211",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7008",
  "hs-promise-utils": "/hs-promise-utils/static-1.5708",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3931",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9138",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3180",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11264",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5627",
  "magpie-types": "/magpie-types/static-1.5087",
  "simple-logging-lib": "/simple-logging-lib/static-1.3164",
  "avatar-components": "/avatar-components/static-1.2613",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9940",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6693",
  "flux-actions": "/flux-actions/static-1.346",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4993",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13945",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5721",
  "laboratory-lib": "/laboratory-lib/static-3.7268",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7897",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10363",
  "unified-auth": "/unified-auth/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "breeze-engine-core": "/breeze-engine-core/static-1.403",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "navigation-messaging": "/navigation-messaging/static-1.7627",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12673",
  "content-media-compositions": "/content-media-compositions/static-2.16680",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19132",
  "social-insights-client-types": "/social-insights-client-types/static-1.22346",
  "advanced-menus-core": "/advanced-menus-core/static-1.15326",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12237",
  "ExportDialog": "/ExportDialog/static-6.10495",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34358",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3882",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4221",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.127",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4088",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6913",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3671",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3775",
  "persist-promise": "/persist-promise/static-1.3815",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5650",
  "fsm": "/fsm/static-1.3843",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.21",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.389",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.585",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.718",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.41",
  "slack-ui-library": "/slack-ui-library/static-1.10511",
  "reactive-lib": "/reactive-lib/static-1.841",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.452",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3131",
  "js-cookie": "/js-cookie/static-1.18",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15325",
  "simple-menus-lib": "/simple-menus-lib/static-1.16842",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9601",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
